import { Case } from 'pco-product-service-internal-consumer';
import { productsAndServicesApi } from 'api';

export const saveTemporaryCase = async (requestBody: Case): Promise<Case> => {
  return await productsAndServicesApi.saveTemporaryCase({ _case: requestBody });
};
